import {Component, Input} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { Field } from '../../../services/requirements/requirements.model';

@Component({
    selector: 'app-profile-fields',
    templateUrl: './profile-fields.component.html',
    styleUrls: ['./profile-fields.component.scss'],
    standalone: true,
    imports: [MatTooltipModule]
})
export class ProfileFieldsComponent {

  @Input()
  fields?: Field[] ;

  getFieldName(field: Field): string {
    switch (field) {
      case "BIO":
        return "bio";
      case "SELFIE":
        return "selfie" ;
    }
    return "" ;
  }

  getFieldDescription(field: Field): string {
    switch (field) {
      case "BIO":
        return "a sentence or so describing yourself, to break the ice";
      case "SELFIE":
        return "a recent photo of yourself, so people can recognize you" ;
    }

    return "" ;
  }

}
